import type {
  ApiResponse,
  ApiResponseShopDetailDto,
} from "../../../shared/types/api";
import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";
import type { BankTransferEntity } from "../../../domain/types/company-bank-transfer";

export class ShopBankTransferApiService {
  async getBankTransfers(shopId: number): Promise<ApiResponse<BankTransferEntity[]>> {
    const response = await httpClient.get<ApiResponse<BankTransferEntity[]>>(
      NEW_API_ENDPOINTS.shopBankTransferController.GET(shopId),
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "쇼핑몰 무통장 정보를 가져오지 못했습니다.",
      );
    }

    return response.data;
  }
}

export const shopBankTransferApiService = new ShopBankTransferApiService();
